import React from "react";
import AddIcon from "@mui/icons-material/Add";
import SettingsIcon from "@mui/icons-material/Settings";
// Common Components
import { Button, DynamicMultiSelectDropdown, Modal } from "src/Components";
// Local Components
import AddLiquidityModal from "./AddLiquidityModal";
import LiquidityManagementTable from "./LiquidityManagementTable";
import SettingModal from "./SettingModal";
// Services
import { getLiquidityUsers } from "src/Requests/imePortfolio";
// Types
import { ILiquidityManagementSearchParams } from "src/Interfaces/imePortfolio";

enum ModalMode {
  Closed,
  Add,
  Setting,
}

const LiquidityManagement: React.FC = () => {
  const [modal, setModal] = React.useState<ModalMode>(ModalMode.Closed);
  const [refreshFlag, setRefreshFlag] = React.useState(false);
  const [userIds, setUserIds] = React.useState<string[]>([]);

  React.useEffect(() => {
    if (refreshFlag) setRefreshFlag(false);
  }, [refreshFlag]);

  const searchParams: ILiquidityManagementSearchParams = React.useMemo(
    () => ({
      userIds,
    }),
    [userIds],
  );

  const getModalUI = React.useMemo(() => {
    switch (modal) {
      case ModalMode.Add:
        return <AddLiquidityModal onSuccess={() => setRefreshFlag(true)} onClose={() => setModal(ModalMode.Closed)} />;
      case ModalMode.Setting:
        return <SettingModal onClose={() => setModal(ModalMode.Closed)}/>;
      default:
        return null;
    }
  }, [modal]);

  return (
    <div className="flex flex-col justify-start items-start gap-3 w-full px-8">
      {modal !== ModalMode.Closed ? (
        <Modal
          title={modal === ModalMode.Add ? "افزودن نقدینگی" : "تنظیمات"}
          UI={getModalUI}
          onClose={() => setModal(ModalMode.Closed)}
          modalBoxClassName="!min-w-min !min-h-min"
        />
      ) : null}

      <div className="flex flex-row justify-between items-start gap-4 w-full p-2">
        <div className="flex flex-col justify-start items-end gap-3 w-44">
          <div className="w-full">
            <Button
              onClick={() => setModal(ModalMode.Setting)}
              text={
                <div className="flex flex-row justify-center items-center gap-1">
                  <SettingsIcon fontSize="small" />
                  <span>تنظیمات</span>
                </div>
              }
              variant="contained"
            />
          </div>

          <div className="w-full">
            <DynamicMultiSelectDropdown
              dropdown={{
                name: "userIds",
                placeholder: "انتخاب اکانت",
              }}
              getData={getLiquidityUsers}
              onChange={(_, value) => setUserIds(value)}
              value={userIds}
              withTagBox
            />
          </div>
        </div>
        <div
          className="bg-sky-600 rounded-full flex justify-center items-center !w-11 !h-11 cursor-pointer"
          onClick={() => setModal(ModalMode.Add)}
        >
          <AddIcon className="text-white" />
        </div>
      </div>
      <LiquidityManagementTable
        searchParams={searchParams}
        refreshFlag={refreshFlag}
      />
    </div>
  );
};

export default LiquidityManagement;
